export type MobileOS = "Android" | "iOS" | "";
export type DeviceType = "mobile" | "desktop" | "unknown";

interface UserAgentDataLike {
  mobile?: boolean;
  platform?: string;
}

export interface NavigatorLike {
  userAgent?: string;
  vendor?: string;
  platform?: string;
  maxTouchPoints?: number;
  userAgentData?: UserAgentDataLike;
}

export interface DeviceInfo {
  mobileOS: MobileOS;
  deviceType: DeviceType;
}

const getBrowserNavigator = (): NavigatorLike => {
  if (typeof navigator === "undefined") return {};
  return navigator as Navigator & { userAgentData?: UserAgentDataLike };
};

export const getDeviceInfo = (
  navigatorValue: NavigatorLike = getBrowserNavigator(),
): DeviceInfo => {
  const userAgent = navigatorValue.userAgent || navigatorValue.vendor || "";
  const platform = navigatorValue.platform || "";
  const userAgentPlatform = navigatorValue.userAgentData?.platform || "";
  const maxTouchPoints = navigatorValue.maxTouchPoints || 0;

  if (/android/i.test(userAgent) || /android/i.test(userAgentPlatform)) {
    return { mobileOS: "Android", deviceType: "mobile" };
  }

  const isIOSUserAgent = /iPad|iPhone|iPod/i.test(userAgent);
  const isIPadOS = /MacIntel/i.test(platform) && maxTouchPoints > 1;
  if (isIOSUserAgent || isIPadOS) {
    return { mobileOS: "iOS", deviceType: "mobile" };
  }

  if (navigatorValue.userAgentData?.mobile === true) {
    return { mobileOS: "", deviceType: "mobile" };
  }

  if (
    navigatorValue.userAgentData?.mobile === false ||
    /Windows NT|Macintosh|X11|CrOS/i.test(userAgent)
  ) {
    return { mobileOS: "", deviceType: "desktop" };
  }

  return { mobileOS: "", deviceType: "unknown" };
};